import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Role } from '../../types/role';
import { api } from '../../services/api';
import { useToast } from '../../components/UI/ToastProvider';
import { Button } from '../../components/UI/Button';

const systemRoles = ['admin', 'manager', 'editor', 'viewer', 'user', 'anonymous'];

export const RolesPage: React.FC = () => {
  const [roles, setRoles] = useState<Role[]>([]);
  const { addToast } = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await api.get('/roles');
      setRoles(response.data);
    } catch (error: any) {
      let msg = 'Erro ao carregar perfis.';
      if (error.response && error.response.data) {
        msg = error.response.data.message || error.response.data.title || msg;
      }
      addToast(msg, 'error');
    }
  };

  const handlePermissions = (role: Role) => {
    navigate(`/admin/roles/${role.id}/permissions`);
  };

  return (
    <div className="p-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Perfis</h1>
      </div>

      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr className="bg-gray-100">
                <th className="py-3 px-4 text-left text-gray-600 font-medium">Nome</th>
                <th className="py-3 px-4 text-left text-gray-600 font-medium">Descrição</th>
                <th className="py-3 px-4 text-left text-gray-600 font-medium">Ações</th>
              </tr>
            </thead>
            <tbody>
              {roles.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center py-4 text-gray-500">
                    Nenhum perfil encontrado.
                  </td>
                </tr>
              ) : (
                roles.map(role => (
                  <tr key={role.id} className="border-b hover:bg-gray-50">
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-2">
                        <span className={`${role.color} ${role.labelColor} text-xs font-medium px-2.5 py-0.5 rounded`}>
                          {role.name}
                        </span>
                        {role.isSystem && (
                          <span className="bg-gray-100 text-gray-600 text-xs font-medium px-2 py-0.5 rounded">
                            Sistema
                          </span>
                        )}
                      </div>
                    </td>
                    <td className="py-3 px-4 text-gray-600">{role.description || '-'}</td>
                    <td className="py-3 px-4">
                      <div className="flex space-x-2">
                        <Button variant="secondary" size="sm" onClick={() => handlePermissions(role)} title="Permissões">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z" />
                          </svg>
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}; 